import request from 'utils/request'

// 获取表格数据
export const getTableData = () => request().get('score/setting/list')

// 添加
export const addItem = data => request().post('score/setting/add', data)
